export {
    PromptInputHeader,
    type PromptInputHeaderProps,
    type ContextItemConfig,
} from './PromptInputHeader';
